import Earth16 from '@carbon/icons-react/es/earth/16';
import React from 'react';
import { ViewType } from 'api/views/types';
import { defaultFilter } from 'components/molecules/filters/utils';
import { Views } from 'components/molecules/views';
import { load } from 'components/molecules/views/core';
import { TimesheetReportViewDefinition } from './types';

export const DEFAULT_VIEW_ID = -1;
export const getDefaultViews = (
  defaultViewName: string,
): Views<TimesheetReportViewDefinition> =>
  load([
    {
      viewId: DEFAULT_VIEW_ID,
      viewName: defaultViewName,
      viewDefinition: {
        filter: defaultFilter,
      },
      createdBy: -1,
      viewIcon: <Earth16 />,
      self: false,
      viewType: ViewType.TimesheetReports,
    },
  ]);
